import { yellow } from '@mui/material/colors';
export const warning_colors = (dark) => ({
    '50': '#FFF9EB',
    '100': '#FFF3C1',
    '200': '#FFECA1',
    '300': '#FFDC48',
    '400': '#F4C000',
    '500': '#DEA500',
    '600': '#D18E00',
    '700': '#AB6800',
    '800': '#8C5800',
    '900': '#5A3600',
    light: dark ? '#ffb74d' : yellow[600],
    main: dark ? '#ffa726' : yellow[800],
    dark: dark ? '#f57c00' : yellow[900],
    contrastText: 'rgba(0, 0, 0, 0.87)',
});
